
import {
  getUserInfo
} from '@/api/login'

import {
  setStorage,
  getStorage
} from '@/utils/storage'

const state = () => ({
  userInfo: {},
  permissions: {},
  roles: [],
  deptVo: {},
  isSuperAdmin: false,
  access_token: getStorage({
    name: 'access_token'
  }) || '',
  refresh_token: getStorage({
    name: 'refresh_token'
  }) || '',
  expires_in: getStorage({
    name: 'expires_in'
  }) || '',
  firstUrl: ''
})


const getters = {
  access_token: state => state.access_token,
  refresh_token: state => state.refresh_token,
  expires_in: state => state.expires_in,
  userInfo: state => state.userInfo,
  permissions: state => state.permissions,
  roles: state => state.roles,
  deptVo: state => state.deptVo,
  isSuperAdmin: state => state.isSuperAdmin,
  firstUrl: state => state.firstUrl
}


const actions = {
  getUserInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getUserInfo().then((res) => {
        const data = res.data.data || {}
        data.sysUser.roleList = data.roleList
        commit('setUserInfo', data.sysUser)
        commit('setRoles', data.roles || [])
        commit('setPremissions', data.permissions || [])
        commit('setDeptVo', data.deptVo || {})
        commit('setIsSuperAdmin', data.isSuperAdmin || false)
        resolve(data)
      }).catch((err) => {
        reject()
      })
    })
  },
  // 注销session
  fedLogOut({commit, rootState}) {
    return new Promise(resolve => {
      commit('setMenuList', [], {root: true})
      commit('setPremissions', [])
      commit('setUserInfo', {})
      commit('setAccessToken', '')
      commit('setRefreshToken', '')
      commit('setRoles', [])
      commit('setNavList', [], {root: true})
      commit('setFirstUrl', '')
      resolve()
    })
  },
}



const mutations = {
  setTokenAbout(state, obj) {
    this.commit('setAccessToken', obj)
    this.commit('setRefreshToken', obj)
    this.commit('setExpiresIn', obj)
  },
  setAccessToken(state, {
    access_token
  }) {
    state.access_token = access_token

    setStorage({
      name: 'access_token',
      content: state.access_token,
      type: 'session'
    })
  },
  setRefreshToken(state, {
    refresh_token
  }) {
    state.refresh_token = refresh_token
    setStorage({
      name: 'refresh_token',
      content: state.refresh_token,
      type: 'session'
    })
  },
  setExpiresIn(state, {
    expires_in
  }) {
    state.expires_in = expires_in
    setStorage({
      name: 'expires_in',
      content: state.expires_in,
      type: 'session'
    })
  },
  setUserInfo: (state, userInfo) => {
    state.userInfo = userInfo
  },
  setRoles: (state, roles) => {
    state.roles = roles
  },
  setPremissions: (state, permissions) => {
    const list = {}
    for (let i = 0; i < permissions.length; i++) {
      list[permissions[i]] = true
    }
    state.permissions = list
  },
  setDeptVo: (state, deptVo)=>{
    state.deptVo = deptVo
  },
  setIsSuperAdmin: (state, isSuperAdmin) => {
    state.isSuperAdmin = isSuperAdmin
  },
  setFirstUrl: (state, firstUrl)=> {
    state.firstUrl = firstUrl
  }

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js